import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import WalletDetailsBackButtonComponent from '../components/WalletDetails/WalletDetailsBackButtonComponent';
import withAuthentication from 'apex-web/lib/hocs/withAuthentication';
import BalancesMenuContainer from 'apex-web/lib/components/BalancesMenu/BalanceMenuContainer';
import WalletDetailsContainer from 'apex-web/lib/components/WalletDetails/WalletDetailsContainer';
import TransfersContainer from 'apex-web/lib/components/Transfers/TransfersContainer';
import TransfersFiltersContainer from 'apex-web/lib/components/Transfers/TransfersFilters';
import RecentActivityWithFilterContainer from 'apex-web/lib/components/RecentActivityWithFilter';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './ProductDetailsPage.css';

const layoutClasses = getBEMClasses('product-details-page');

const backPath = '/wallets';

const ProductDetailsPage = (props, context) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  return (
    <React.Fragment>
      <div className={layoutClasses()}>
        <div className={layoutClasses('container')}>
          <div className={layoutClasses('menu')}>
            <WalletDetailsBackButtonComponent key="1" path={backPath} />
            <BalancesMenuContainer key="2" />
          </div>
          <div className={layoutClasses('content')}>
            <div className={layoutClasses('wallet-details')}>
              <WalletDetailsContainer />
            </div>
            <div className={layoutClasses('transfers')}>
              <div className={layoutClasses('transfers-header')}>
                {context.t('Transfers')}
              </div>
              <TransfersFiltersContainer />
              <TransfersContainer />
            </div>
            <div
              className={layoutClasses('activity', {
                'filters-open': filtersOpen
              })}>
              <button
                type="button"
                className={layoutClasses('activity-filters-toggle', {
                  active: filtersOpen
                })}
                aria-expanded={filtersOpen}
                aria-label={context.t('Filters')}
                onClick={() => setFiltersOpen(open => !open)}>
                <svg
                  className={layoutClasses('activity-filters-toggle-icon')}
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                <span>{context.t('Filters')}</span>
              </button>
              <RecentActivityWithFilterContainer filterForSelected={true} />
            </div>
          </div>
        </div>
      </div>
      <PageFooterLayout />
    </React.Fragment>
  );
};

ProductDetailsPage.contextTypes = {
  t: PropTypes.func.isRequired
};

export default withAuthentication(ProductDetailsPage);
